import { useCssModule, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
const SHAPES = {
  rounded: {
    name: "rounded",
    class: "isRounded"
  },
  circle: {
    name: "circle",
    class: "isCircle"
  }
};
const VALID_SHAPES = ["", ...Object.keys(SHAPES)];
const xSkeletonLoader = "_xSkeletonLoader_ogmln_1";
const wave = "_wave_ogmln_1";
const isRounded = "_isRounded_ogmln_18";
const isCircle = "_isCircle_ogmln_21";
const style0 = {
  xSkeletonLoader,
  wave,
  isRounded,
  isCircle
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XSkeletonLoader"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    height: {
      type: String,
      default: "100px"
    },
    width: {
      type: String,
      default: "100%"
    },
    shape: {
      type: String,
      default: "",
      validator: (shape) => VALID_SHAPES.includes(shape)
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const $style = useCssModule();
    const { t } = useI18n();
    const { formatTestId } = setupTestId(props);
    const isCircle2 = computed(() => props.shape === SHAPES.circle.name);
    const isRounded2 = computed(() => props.shape === SHAPES.rounded.name);
    const loaderStyles = computed(() => ({
      width: props.width,
      height: isCircle2.value ? props.width : props.height
    }));
    const loaderClasses = computed(() => ({
      [$style[SHAPES.rounded.class]]: isRounded2.value,
      [$style[SHAPES.circle.class]]: isCircle2.value
    }));
    return { __sfc: true, createTestIdProp, setupTestId, props, $style, t, formatTestId, isCircle: isCircle2, isRounded: isRounded2, loaderStyles, loaderClasses };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_setup.$style.xSkeletonLoader, _setup.loaderClasses], style: _setup.loaderStyles, attrs: { "role": "progressbar", "aria-busy": "true", "aria-label": _setup.t("ds.xSkeletonLoader.loading"), "data-testid": _setup.formatTestId() } });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XSkeletonLoader = __component__.exports;
export {
  XSkeletonLoader as default
};
